export const phoneTypeList = ["Mobile", "Phone", "Fax"];
